/**
 * Shared container for document preview forms.
 * Provides the A4-width paper styling and consistent paragraph spacing
 * so individual documents don't need ad-hoc margin classes on body text.
 */
import type { ReactNode } from 'react'

interface DocumentPreviewProps {
  children: ReactNode
}

export function DocumentPreview({ children }: DocumentPreviewProps) {
  return (
    <div className="document-preview mx-auto max-w-[210mm] rounded border bg-white p-10 shadow-sm [&>p+p]:mt-3">
      {children}
    </div>
  )
}
